import { useState, useRef, useEffect } from 'react';

function toSafeNumber(v) {
  if (v == null) return '';
  if (typeof v === 'object') return '';
  return v;
}

export default function NumberCell({ value, onChange, readOnly = false }) {
  const [editing, setEditing] = useState(false);
  const [text, setText] = useState(toSafeNumber(value));
  const inputRef = useRef(null);

  useEffect(() => { setText(toSafeNumber(value)); }, [value]);
  useEffect(() => {
    if (editing && inputRef.current) { inputRef.current.focus(); inputRef.current.select(); }
  }, [editing]);

  const save = () => {
    setEditing(false);
    const num = text === '' ? null : Number(text);
    if (num !== value) onChange(num);
  };

  if (editing && !readOnly) {
    return (
      <input
        ref={inputRef}
        type="number"
        value={toSafeNumber(text)}
        onChange={(e) => setText(e.target.value)}
        onBlur={save}
        onKeyDown={(e) => {
          if (e.key === 'Enter') save();
          if (e.key === 'Escape') { setText(toSafeNumber(value)); setEditing(false); }
        }}
        className="w-full h-full bg-transparent border-none outline-none text-text-primary text-sm px-2 text-right"
      />
    );
  }

  return (
    <div
      onClick={() => { if (!readOnly) setEditing(true); }}
      className={`w-full h-full flex items-center justify-end px-2 text-sm text-text-primary transition-colors min-h-[40px] ${readOnly ? '' : 'cursor-pointer hover:bg-white/5'}`}
    >
      {value != null && typeof value !== 'object' ? value : <span />}
    </div>
  );
}
